import React from 'react';
import PropTypes from 'prop-types';
import LocaleText from '../../LocaleText';
import Checkbox from '../../Checkbox';

class ConfirmationPopup extends React.Component {
    render() {
        const classes = ['popup', 'popup--centered', 'confirmation-popup'];
        const { onConfirm, onCancel, onCheckboxChange, isVisible, shouldDisable } = this.props;
        if (!isVisible) {
            return null;
        }
        if (/iPhone/.test(navigator.userAgent) && !window.MSStream) {
            classes.push('is-iphone');
        }
        return (
            <div className={classes.join(' ')}>
                <div className="popup__box">
                    <header className="popup__header">
                        <h3 className="popup__title">
                            <LocaleText textKey="template.warning.popup.title" />
                        </h3>
                    </header>
                    <div className="popup__body">
                        <p className="popup__text">
                            <LocaleText textKey="template.warning.popup.text" />
                        </p>
                    </div>
                    <div className="buttons">
                        <button onClick={onCancel}>
                            <LocaleText textKey="template.warning.popup.cancel" />
                        </button>
                        <button className="is-primary" onClick={onConfirm}>
                            <LocaleText textKey="template.warning.popup.confirm" />
                        </button>
                    </div>
                    <div>
                        <Checkbox
                            classes={['popup__checkbox']}
                            checked={shouldDisable}
                            name="do-not-show-template-warning-again"
                            type="checkbox"
                            onChange={onCheckboxChange}
                            label={<LocaleText textKey="template.warning.popup.checkbox.label" />}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

ConfirmationPopup.propTypes = {
    onConfirm: PropTypes.func.isRequired,
    onCancel: PropTypes.func.isRequired,
    onCheckboxChange: PropTypes.func.isRequired,
    isVisible: PropTypes.bool.isRequired,
    shouldDisable: PropTypes.bool.isRequired,
};

ConfirmationPopup.defaultProps = {};

export default ConfirmationPopup;
